import React, { useCallback } from 'react';
import { MediaQueueTile } from '@cube3/ui/src/Prefabs/MediaQueue/MediaQueueTile';
import { useResource__ALPHA } from '@cube3/state/src/redux/components/Hooks/useResource';
import Thumbnail from '@cube3/ui/src/thumbnails/Thumbnail';
import Time from '@cube3/cubicle/src/core/utility/Time';
import { LibraryItemOverlay } from '@cube3/ui/src/library/LibraryItemOverlay';

import { statuses } from '@cube3/state/src/redux/ducks/request-status';
import fileImage from '@cube3/ui/src/assets/images/Library/file.svg?url';

import { MediaQueueTileLoading } from '../MediaQueueTileLoading';
import { iconReplay } from '@cube3/ui/src/icons/GeneralSVG';

import { UploadBreadcrumbs } from '../UploadBreadcrumbs';
import { useDeleteResource__ALPHA } from '@cube3/state/src/redux/components/Hooks/useDeleteResource';

const deleteConfig = { cacheInvalidator: null };

export const UploadQueueListItemUnavailable = ({
  nodeId,
  upload,
  deleted = false
}) => {
  const nodeResource = useResource__ALPHA({
    resourceType: 'content-tree-node',
    resourceId: nodeId
  });

  const permanentlyDeleted =
    nodeResource.status === statuses.FAILED ||
    nodeResource.first?.permanently_deleted_at;

  const { retrieve } = useResource__ALPHA({
    resourceType: 'asset',
    resourceId: nodeId || upload?.asset_id,
    strategy: 'cache-only'
  });

  const [deleteResource] = useDeleteResource__ALPHA(deleteConfig);

  const onClickRemoveUpload = useCallback(() => {
    if (!deleted) {
      retrieve();
      return;
    }
    if (upload) {
      if (upload.tusUpload) {
        upload.tusUpload.abort(false).then(() => {
          deleteResource({ type: 'file-upload', id: upload.id }, true);
        });
      } else {
        deleteResource({ type: 'file-upload', id: upload.id }, true);
      }
    }
  }, [upload, deleteResource, deleted, retrieve]);

  if (permanentlyDeleted) {
    return (
      <li style={{ listStyle: 'none' }}>
        <MediaQueueTileLoading
          title={'Asset missing for upload'}
          status="failed"
          statusLabel="Asset permanently deleted"
          onCloseClick={onClickRemoveUpload}
        />
      </li>
    );
  }

  return (
    <li style={{ listStyle: 'none' }}>
      <MediaQueueTile
        title={
          nodeResource.first?.display_name ||
          (deleted ? 'Deleted asset' : 'Unavailable')
        }
        thumb={
          <LibraryItemOverlay
            front={null}
            back={
              <Thumbnail src={fileImage} cover={false} ratio="sixteenToNine" />
            }
          />
        }
        contextRow={<UploadBreadcrumbs deleted={deleted} />}
        timestampRow={
          <span>
            Last activity{' '}
            <Time date={upload?.updated_at || nodeResource.first.updated_at} />
          </span>
        }
        status="failed"
        statusLabel={deleted ? 'Asset deleted' : 'Asset unavailable'}
        onCloseClick={onClickRemoveUpload}
        onCloseClickTooltip={!deleted && 'Reload'}
        onCloseClickIcon={!deleted && iconReplay}
      />
    </li>
  );
};
